import classNames from "classnames";

export interface ContentProps {
  children: React.ReactNode;
  className?: string;
}

export const Content = ({ className, children }: ContentProps) => (
  <span className={classNames("truncate", className)}>{children}</span>
);
